<div class="sidenav fx-column" *ngIf="mode !== 'hidden'">
    <ng-container *ngFor="let section of navigationButtonSections; let i = index">
        <ng-container *ngIf="section.buttons.length">
            <!-- section -->
            <div class="section-name" [class.active]="section.active" *ngIf="section.sectionName">
                {{ section.sectionName }}
            </div>

            <!-- Navigation buttons -->
            <ng-container *ngFor="let btn of section.buttons">
                <a
                    [routerLinkActive]="'active'"
                    mat-icon-button
                    [routerLink]="[btn.routerLink]"
                    [matTooltip]="btn.name | translate"
                    matTooltipPosition="right"
                >
                    <mat-icon [svgIcon]="btn.svgIcon"></mat-icon>
                </a>
            </ng-container>
        </ng-container>
        <span *ngIf="i == 0 && isChargEye && !(isMyKempower$ | async)">
            <span *ngIf="skipDialog">
                <a
                    target="_self"
                    [href]="betaLink"
                    class="sidenav-CeBetaLink"
                    [matTooltip]="'Go to ChargEye beta'"
                    matTooltipPosition="right"
                    rel="noopener"
                >
                    <div>
                        <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.97826 8.65218V11H4.02174V8.65218H6.5V7.6087H4.02174V5H2.97826V7.6087H0.5V8.65218H2.97826Z"
                                fill="white"
                                fill-opacity="0.9"
                            />
                            <path
                                d="M24.5652 3.04348V5H25.4348V3.04348H27.5V2.17392H25.4348V0H24.5652V2.17392H22.5V3.04348H24.5652Z"
                                fill="white"
                                fill-opacity="0.9"
                            />
                            <path
                                d="M26.8043 14.8696V18H28.1957V14.8696H31.5V13.4783H28.1957V10H26.8043V13.4783H23.5V14.8696H26.8043Z"
                                fill="white"
                                fill-opacity="0.9"
                            />
                            <path
                                d="M11.4 20L12.2 14.4H8.20001L15.4 4H17L16.2 10.4H21L13 20H11.4Z"
                                fill="white"
                                fill-opacity="0.9"
                            />
                        </svg>
                    </div>
                    ChargEye beta
                </a>
            </span>
            <span *ngIf="!skipDialog">
                <button
                    *ngIf="i == 0 && isChargEye && !(isMyKempower$ | async)"
                    class="sidenav-CeBetaLink"
                    (click)="navigateToBeta()"
                    [matTooltip]="'Go to ChargEye beta'"
                    matTooltipPosition="right"
                >
                    <div>
                        <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.97826 8.65218V11H4.02174V8.65218H6.5V7.6087H4.02174V5H2.97826V7.6087H0.5V8.65218H2.97826Z"
                                fill="white"
                                fill-opacity="0.9"
                            />
                            <path
                                d="M24.5652 3.04348V5H25.4348V3.04348H27.5V2.17392H25.4348V0H24.5652V2.17392H22.5V3.04348H24.5652Z"
                                fill="white"
                                fill-opacity="0.9"
                            />
                            <path
                                d="M26.8043 14.8696V18H28.1957V14.8696H31.5V13.4783H28.1957V10H26.8043V13.4783H23.5V14.8696H26.8043Z"
                                fill="white"
                                fill-opacity="0.9"
                            />
                            <path
                                d="M11.4 20L12.2 14.4H8.20001L15.4 4H17L16.2 10.4H21L13 20H11.4Z"
                                fill="white"
                                fill-opacity="0.9"
                            />
                        </svg>
                    </div>
                    ChargEye beta
                </button>
            </span>
        </span>
    </ng-container>
</div>
